module.exports = __webpack_public_path__ + "static/media/Risk.07fee65f.jpg";